import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid2,
  Typography,
} from '@mui/material';
import React from 'react';
import { SearchVehicleModels } from 'types';

import acIcon from 'assets/images/product-features/ac.svg';
import doorIcon from 'assets/images/product-features/door.svg';
import luggageIcon from 'assets/images/product-features/luggage.svg';
import seatIcon from 'assets/images/product-features/seat.svg';
import transmissionIcon from 'assets/images/product-features/transmission.svg';
import { Vehicle } from 'types/products';

export const Product: React.FC<{ data: Vehicle }> = ({ data }) => {
  const currency = 'AED';
  return (
    <Card className="product-card" sx={{ borderRadius: 5 }}>
      <Box sx={{ height: 'auto', minHeight: '300px', maxHeight: '300px' }}>
        {data.VehicleImage && data.VehicleImage ? (
          <CardMedia
            component="img"
            style={{ height: 'auto', minHeight: '300px', maxHeight: '300px' }}
            image={
              data.VehicleImage.includes('https')
                ? data.VehicleImage
                : `https://fcdn.thriftyuae.com/media/${data.VehicleImage}`
            }
            alt={data.Name}
            sx={{ objectFit: 'contain' }}
          />
        ) : (
          <img
            src={`https://fcdn.thriftyuae.com/media/vehicle/no-image.png`}
            alt="No Image Available"
            style={{ height: '300px', objectFit: 'contain' }}
          />
        )}
      </Box>
      <CardContent className="product-details" sx={{ padding: '10px' }}>
        <Box className="product-name">
          <Typography variant="body1" gutterBottom sx={{ textAlign: 'start' }}>
            {data.Name}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {data.ModelYear} | Petrol |{' '}
            {data.AutoTransmission ? 'Automatic' : 'Manual'}
          </Typography>
        </Box>
        <Grid2
          container
          spacing={0}
          sx={{
            justifyContent: 'space-around',
            borderBottom: '1px solid #C2CDD4',
            padding: '10px',
          }}
        >
          <Grid2 size={{ xs: 2 }} textAlign="center">
            <Box>
              <Typography variant="body2">Seats</Typography>
              <img src={seatIcon} alt="seat-icon" />
              <Typography variant="body2">{data.Passengers}</Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 2 }} textAlign="center">
            <Box>
              <Typography variant="body2">Luggage</Typography>
              <img src={luggageIcon} alt="luggage-icon" />
              <Typography variant="body2">{data.Luggages}</Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 2 }} textAlign="center">
            <Box>
              <Typography variant="body2">Doors</Typography>
              <img src={doorIcon} alt="door-icon" />
              <Typography variant="body2">{data.Doors}</Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 2 }} textAlign="center">
            <Box>
              <Typography variant="body2">
                {data.AC ? 'AC' : 'No AC'}
              </Typography>
              <img src={acIcon} alt="ac-icon" />
              <Typography variant="body2">{data.AC ? 'Yes' : 'No'}</Typography>
            </Box>
          </Grid2>
          <Grid2 size={{ xs: 2 }} textAlign="center">
            <Box>
              <Typography variant="body2">
                {data.AutoTransmission && 'Transmission'}
              </Typography>
              <img src={transmissionIcon} alt="transmission-icon" />
              <Typography variant="body2">
                {data.AutoTransmission ? 'Auto' : 'Manual'}
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
        <Box
          sx={{
            borderBottom: '1px solid #C2CDD4',
            padding: '10px',
          }}
        >
          <Typography className="payment-text">
            Pay Now: <span className="currency-tag">{currency}</span>
            <span className="price">
              {data.RentalCharges.PayNowRate.toLocaleString()}
            </span>
            <span className="booking-duration">
              {'for your '}
              {data.RentalCharges.RentalDays}
              {data.RentalCharges.RentalDays > 1 ? ' days' : ' day'} rental
            </span>
          </Typography>

          <Typography className="payment-text">
            Pay Later: <span className="currency-tag">{currency}</span>
            <span className="price">
              {data.RentalCharges.PayLaterRate.toLocaleString()}
            </span>
            <span className="booking-duration">
              {'for your '}
              {data.RentalCharges.RentalDays}
              {data.RentalCharges.RentalDays > 1 ? ' days' : ' day'} rental
            </span>
          </Typography>
        </Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 2, display: 'block', textAlign: 'center' }}
        >
          (Inclusive of VAT)
        </Typography>
      </CardContent>
    </Card>
  );
};
